module.exports = __webpack_public_path__ + "static/shipkoo-eu-map-406bb7eb146094911f5df3b4d977b429.png";